import { RegisterOptions } from 'react-hook-form'

export const emailValidationRule: Pick<RegisterOptions, 'pattern'> = {
  pattern: {
    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    message: 'Please enter a valid email address',
  },
}
